/**
 * Side-channel mapping composer attachment ids ("type:id", the
 * assistant-ui id format from `toAuiAttachment`) to the owning client of
 * the underlying library item. assistant-ui's `CompleteAttachment` has no
 * slot for domain metadata, so the attach flow registers it here and the
 * composer pill row reads it back at render time to surface the
 * cross-client scope warning. Same module-state pattern as the adapter's
 * `setNextClientId` staging channel.
 *
 * Entries are written synchronously before `composer.addAttachment` (which
 * triggers the re-render that reads them), so render-time reads are never
 * stale. Stale leftovers after removal are harmless: only ids present in
 * the live composer state are ever looked up, and a re-attach of the same
 * item overwrites its entry.
 */

const clientIdByAttachmentId = new Map<string, number>();

export function registerAttachmentClient(
    attachmentId: string,
    clientId: number | null | undefined
): void {
    if (clientId == null) {
        clientIdByAttachmentId.delete(attachmentId);
        return;
    }
    clientIdByAttachmentId.set(attachmentId, clientId);
}

export function getAttachmentClientId(attachmentId: string): number | null {
    return clientIdByAttachmentId.get(attachmentId) ?? null;
}

/** Test-only reset so suites can't poison each other through module state. */
export function clearAttachmentClientRegistry(): void {
    clientIdByAttachmentId.clear();
}
